export type StageDef = {
  key: string
  path: string
  name: string
  longName: string
}

const EVENTS = {
  key: 'events',
  path: '/veranstaltungen',
  name: 'Veranstaltungen',
  longName: 'Veranstaltungen auswählen',
} as StageDef

const REGISTRATIONS = {
  key: 'registrations',
  path: '/anmeldungen',
  name: 'Anmeldungen',
  longName: 'Anmeldungen bestätigen',
} as StageDef

const PARTICIPANT = {
  key: 'participant',
  path: '/teilnehmer',
  name: 'Teilnehmer',
  longName: 'Persönliche Angaben',
} as StageDef

const PAYMENT = {
  key: 'payment',
  path: '/bezahlung',
  name: 'Bezahlung',
  longName: 'Bezahlung',
} as StageDef

const VERIFY = {
  key: 'verify',
  path: '/überprüfen',
  name: 'Überprüfen',
  longName: 'Daten überprüfen',
} as StageDef

const SUCCESS = {
  key: 'success',
  path: '/fertig',
  name: 'Abschließen',
  longName: 'Verbindlich abschicken',
} as StageDef

const stages = [EVENTS, REGISTRATIONS, PARTICIPANT, PAYMENT, VERIFY, SUCCESS]

export { EVENTS, REGISTRATIONS, PARTICIPANT, PAYMENT, VERIFY, SUCCESS, stages }
